/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cognito_identity_pool_id": "eu-west-1:9ba5dfbf-b268-479e-880f-0a32ca2951d5",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_9Nj0ttEbB",
    "aws_user_pools_web_client_id": "5p1637lh1hjrgoffuri29rqifm",
    "oauth": {},
    "aws_content_delivery_bucket": "romatch-20200405201628-hostingbucket-production",
    "aws_content_delivery_bucket_region": "eu-west-1",
    "aws_content_delivery_url": "https://d1wg1bx6bwhee5.cloudfront.net",
    "aws_appsync_graphqlEndpoint": "https://2vuo2lzm3vdcdp5hh7in42ltqm.appsync-api.eu-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-eg3hns5zjvbn5k3646ntv77sua",
    "aws_cloud_logic_custom": [
        {
            "name": "romatchcontactapi",
            "endpoint": "https://1qtr7cfepa.execute-api.eu-west-1.amazonaws.com/production",
            "region": "eu-west-1"
        }
    ],
    "aws_user_files_s3_bucket": "romatchstoragebucket201145-production",
    "aws_user_files_s3_bucket_region": "eu-west-1"
};


export default awsmobile;
